import React from 'react';
import DatePicker from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import { datepicker_jp as config } from '../Const';

interface Props {
  id: string;
  className?: string;
  customInput?: JSX.Element;
  disabled?: boolean;
  handleChangeDate: (date: Date) => void;
  help_msg?: string;
  name?: string;
  selected: Date | null;
  placeholder?: string;
  handleBlur?: VoidFunction;
  minDate?: Date;
  maxDate?: Date;
}

const DatePickerJp: React.FC<Props> = ({
  id,
  className,
  customInput,
  selected,
  handleChangeDate,
  placeholder,
  name,
  disabled,
  handleBlur,
  minDate,
  maxDate,
}) => {
  // get Years
  const years: number[] = [];
  const yearNow = new Date().getFullYear();
  const yearFrom = yearNow + config.year_from;
  const yearTo = yearNow - config.year_to;

  for (let i = yearFrom; i >= yearTo; i--) {
    years.push(i);
  }

  const months = [
    '1月',
    '2月',
    '3月',
    '4月',
    '5月',
    '6月',
    '7月',
    '8月',
    '9月',
    '10月',
    '11月',
    '12月',
  ];

  const handleOnClick = (value: Date) => {
    handleChangeDate(value);
  };

  return (
    <DatePicker
      id={id}
      className={className}
      disabled={disabled}
      locale={ja}
      onChange={handleOnClick}
      selected={selected ?? null}
      placeholderText={placeholder}
      name={name}
      dateFormat="yyyy年MM月dd日"
      customInput={customInput}
      showPopperArrow={false}
      onBlur={handleBlur}
      minDate={minDate}
      maxDate={maxDate}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div>
          <button
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className="react-datepicker__navigation react-datepicker__navigation--previous"
          >
            {'<'}
          </button>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(Number(value))}
          >
            {years.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <span>年</span>
          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
          >
            {months.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <button
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className="react-datepicker__navigation react-datepicker__navigation--next"
          >
            {'>'}
          </button>
        </div>
      )}
    />
  );
};

export default DatePickerJp;
